import { c as _c } from "react/compiler-runtime";
import { TourFilterRoomTime } from "@website/accommodation-ui/tour-result-header/tour-filter-room-time/tour-filter-room-time";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { MouseEvent, useState } from "react";
interface Properties {
  cityName: string;
  hasSelected: boolean;
  reset: () => void;
}
export function TourFilterRoomButtonModal(t0) {
  const $ = _c(27);
  const {
    cityName,
    hasSelected,
    reset
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function toggleModal() {
      setIsModalOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleModal = t1;
  let t2;
  if ($[1] !== reset) {
    t2 = function onReset(event) {
      event?.preventDefault();
      event?.stopPropagation();
      reset();
    };
    $[1] = reset;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onReset = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon className="text-sm" name="airplanemode_active" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hasSelected || $[5] !== onReset) {
    t4 = hasSelected ? <MaterialIcon className="relative z-[9] cursor-pointer" name="cancel" variant="fill" onClick={onReset} /> : null;
    $[4] = hasSelected;
    $[5] = onReset;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = hasSelected ? "secondary" : "neutral";
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Button StartIcon={t3} EndIcon={t4} color={t5} onClick={toggleModal} size="small" variant="round-outline" className="whitespace-nowrap">زمان حمل‌ونقل</Button>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== cityName) {
    t7 = <TourFilterRoomTime cityName={cityName} />;
    $[10] = cityName;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !hasSelected;
  let t9;
  if ($[12] !== onReset || $[13] !== t8) {
    t9 = <Button className="w-[140px]" color="secondary" onClick={onReset} text={"\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627"} variant="text" disabled={t8} />;
    $[12] = onReset;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button className="w-[140px]" color="secondary" onClick={toggleModal} text={"\u0627\u0639\u0645\u0627\u0644"} variant="contained" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t9) {
    t11 = <div className="flex w-full flex-row items-center justify-between">{t9}{t10}</div>;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t7) {
    t12 = <div className="flex !w-full flex-col px-4 pb-4">{t7}{t11}</div>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isModalOpen || $[22] !== t12) {
    t13 = <MiniPopover onClose={toggleModal} open={isModalOpen} title={"\u0632\u0645\u0627\u0646 \u062D\u0645\u0644\u200C\u0648\u0646\u0642\u0644"}>{t12}</MiniPopover>;
    $[21] = isModalOpen;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t6) {
    t14 = <div className="relative">{t6}{t13}</div>;
    $[24] = t13;
    $[25] = t6;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}
function _temp(isModalOpen_0) {
  return !isModalOpen_0;
}